<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section three-quarters">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <nz-row [nzGutter]="[16, 16]">
      <nz-col [nzSpan]="24">
        <h1
          class="title"
          i18n="@@page-story-viewer-content-title"
          nz-typography>
          Anonymous <u>Instagram</u> story viewer
        </h1>
      </nz-col>
      <nz-col [nzSpan]="24">
        <app-search-form [valueConsumer]="valueBehaviorSubject$" />
      </nz-col>
      <nz-col [nzSpan]="24">
        <app-profile-examples [valuePublisher]="valueBehaviorSubject$" />
      </nz-col>
      <nz-col [nzSpan]="24" class="ya-banner" id="yandex_rtb_R-A-15626278-5">
      </nz-col>
    </nz-row>
  </nz-col>
</nz-row>
<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section half bg-dark-grey">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <app-greetings [greetingsDTO]="greetingsDTO" />
  </nz-col>
</nz-row>
<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section full bg-light-grey">
  <nz-col
    [nzLg]="{ span: 18, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <app-benefits [benefitsDTO]="benefitsDTO" />
  </nz-col>
</nz-row>
